import React from 'react';
import {
  FDDialog,
} from '@facet-wealth/design';
import DataContainer from 'Components/UI/DataContainer';
import {
  useOnboardingCapacity,
} from 'Components/AdvisorApp/Viewport/Users/OnboardingCapacityDialog/useOnboardingCapacity';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import OnboardingCapacityDialogContent
  from 'Components/AdvisorApp/Viewport/Users/OnboardingCapacityDialog/OnboardingCapacityDialogContent';

const OnboardingCapacityDialog = ({
  open,
  onClose,
  onboardingCapacityRelationship,
}) => {
  const {
    loading,
    loadingError,
    submitting,
    onboardingCapacityResource,
    newOnboardingCapacityItemResource,
    submitNewOnboardingCapacityItem,
    deleteOnboardingCapacityItem,
  } = useOnboardingCapacity(onboardingCapacityRelationship);

  return (
    <FDDialog open={open} onClose={onClose} dialogWidth={'lg'}>
      <DataContainer
        loading={loading}
        loadingError={loadingError}
        component={() => (
          <MetaResourceRenderer
            layout={OnboardingCapacityDialogContent}
            resource={onboardingCapacityResource}
            LayoutProps={{
              onClose,
              newOnboardingCapacityItemResource,
              deleteOnboardingCapacityItem,
              submitNewOnboardingCapacityItem,
              submitting,
            }}
          />
        )}
      />
    </FDDialog>
  );
};


export { OnboardingCapacityDialog };
